import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../services/auth.service';

import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { AmazingTimePickerService } from '../shared/time-picker-compat/amazing-time-picker.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {
  loginData = JSON.parse(localStorage.getItem('logindata'))
  isDisable: boolean = true
  imageUrlArray: any = []
  reminder: any = {}
  minDateValue: Date = new Date()
  @ViewChild("placesRef") placesRef: GooglePlaceDirective
  options = {
    types: [],
    componentRestrictions: { country: 'in' }
  }
  reminders: any = []
  showEye: boolean = true
  constructor(private auth: AuthService, private toaster: ToastrService, public datePipe: DatePipe, private atp: AmazingTimePickerService) { }

  ngOnInit() {
    this.loginData.profilePicture = this.loginData.profilePicture == '' ? 'assets/images/user-img.jpg' : this.loginData.profilePicture
    this.loginData.pincode = !this.loginData.pincode ? null : this.loginData.pincode
    this.loginData.dob = !this.loginData.dob ? null : this.datePipe.transform(new Date(this.loginData.dob), 'MMMM LL yyyy')
    this.loginData.password = ''
    this.listReminder()

  }
  setReminder(form: NgForm) {
    console.log(this.reminder)
    let time: any
    let hours: any
    //return false
    if (form.valid) {
      let month = new Date(this.reminder.date).getMonth() + 1
      let date = new Date(this.reminder.date).getFullYear() + '/' + month + '/' + new Date(this.reminder.date).getDate()
      if (this.reminder.time.split(' ')[1] == 'am' && parseInt(this.reminder.time.split(' ')[0].split(':')[0]) == 12) {
        time = '00' + ':' + this.reminder.time.split(' ')[0].split(':')[1]
      }
      else {
        if (this.reminder.time.split(' ')[1] == 'am') {
          time = this.reminder.time.split(' ')[0]
        }
        else {
          if (parseInt(this.reminder.time.split(' ')[0].split(':')[0]) == 12) {
            time = '12' + ':' + this.reminder.time.split(' ')[0].split(':')[1]
          }
          else {
            hours = parseInt(this.reminder.time.split(' ')[0].split(':')[0]) + 12
            time = hours + ':' + this.reminder.time.split(' ')[0].split(':')[1]
          }
        }
      }

      this.reminder.timeStamp = Math.round(new Date(date + ' ' + time).getTime())

      this.auth.setReminder(this.reminder).subscribe(res => {
        this.toaster.success('Reminder Added Successfully..', 'Success', {
          timeOut: 2000
        });
        console.log(res)
        this.reminders.push(res["data"])
        this.reminder = {}
      }, error => {
        this.toaster.error(error.error.message, 'Error', {
          timeOut: 2000
        });
      })
    }
  }
  deleteReminder(reminderId) {
    this.auth.deleteReminder(reminderId).subscribe(res => {
      this.toaster.success('Reminder Deleted..', 'Success', {
        timeOut: 2000
      });

      this.listReminder()
    }, error => {
      console.log(error)
      this.toaster.error(error.error.message, 'Error', {
        timeOut: 2000
      });
    })

  }
  listReminder() {
    this.auth.listReminder().subscribe(res => {
      console.log(res)
      this.reminders = res["data"]
    })
  }
  tConvert(time) {
    // Check correct time format and split into components
    //time = '12:28'
    let time1 = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    let time2: any

    if (time1.length > 1) { // If time format correct
      time2 = time1.slice(1);  // Remove full string match value
      time2[5] = +time2[0] < 12 ? ' am' : ' pm'; // Set AM/PM
      time2[0] = +time2[0] % 12 || 12; // Adjust hours
    }
    else {

    }
    //console.log(time2)
    return time2.join('') // return adjusted time or original string
  }
  open() {
    const amazingTimePicker = this.atp.open();
    amazingTimePicker.afterClose().subscribe(time => {
      this.reminder.time = this.tConvert(time)
      // this.selectedTime = time;
    });
  }
  fileChanged(event) {
    if (event.target.files.length) {
      this.auth.fileUpload(event.target.files[0]).subscribe(res => {
        this.loginData.profilePicture = res['data']['thumb']
      },
        error => {
          alert('There was some error')
        })
    }
  }
  handleAddressChange(event: Address) {
    console.log(event)
    let flag = 0
    let flag1 = 0

    this.loginData.city = ''
    this.loginData.state = ''
    this.loginData.country = ''
    this.loginData.pincode = ''
    this.loginData.lat = 0
    this.loginData.lng = 0

    let address_components = event.address_components.map((addr: any) => {


      if (addr.types[0] == 'locality' && addr.types[1] == 'political') {
        this.loginData.city = addr.long_name.toLowerCase()
        flag = 1

      }

      if (addr.types[0] == 'administrative_area_level_1' && addr.types[1] == 'political') {
        this.loginData.state = addr.long_name
        flag1 = 1

      }
      if (addr.types[0] == 'country' && addr.types[1] == 'political') {
        this.loginData.country = addr.long_name
        flag1 = 1

      }
      if (addr.types[0] == 'postal_code') {
        this.loginData.pincode = addr.long_name
        flag1 = 1

      }


    })
    if (flag == 0)
      this.loginData.city = event.formatted_address.split(',')[0].toLowerCase()

    //this.realAddress=true
    // console.log(event.formatted_address)
    this.loginData.address = event.formatted_address

    this.loginData.lat = event.geometry.location.lat()
    this.loginData.lng = event.geometry.location.lng()
  }
  showImage(image) {
    this.imageUrlArray = []
    this.imageUrlArray.push(image)
    document.getElementById('orderImagesCLick').click()
  }
  editProfile() {
    this.isDisable = !this.isDisable
    this.loginData.dob = new Date(this.loginData.dob)
    console.log(this.loginData.dob)
  }
  numberOnly(event, id): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
  }
  updateProfile(form: NgForm) {
    if (form.valid) {
      this.loginData.city = this.loginData.city.toLowerCase()
      this.auth.profileUpdate('user', this.loginData).subscribe(res => {
        this.toaster.success('Profile Updated Successfully..', 'Success', {
          timeOut: 2000
        });
        console.log(res["data"])
        localStorage.setItem('logindata', JSON.stringify(res["data"]))
        // this.loginData.dob = 
        //this.loginData = res["data"]
        this.isDisable = true
        this.loginData.dob = !this.loginData.dob ? null : this.datePipe.transform(this.loginData.dob, 'MMMM dd yyyy')



      },


        error => {
          console.log(error)

          this.toaster.error('There was some error updating...', 'Error', {
            timeOut: 2000
          })
        })
    }

  }

}
